import { useEffect, useMemo } from 'react';

import { expValEquals } from '@confluence/feature-experiments';
import { useIsTransition } from '@confluence/route-manager/entry-points/RouteState.ts';

import type { PreloadedSearchPayload } from './preloadSearch.ts';

export const usePreloadDataProvider = () => {
	const isTransition = useIsTransition();

	useEffect(() => {
		if (isTransition) {
			delete window.__PRELOADED_SEARCH__;
		}
	}, [isTransition]);

	return useMemo(
		() => ({
			getPreloadedSearch: ({
				cloudId: requestedCloudId,
			}: {
				cloudId: string;
			}): PreloadedSearchPayload | null => {
				if (!expValEquals('search_config_ssr', 'isEnabled', true)) {
					return null;
				}

				if (isTransition) {
					return null;
				}

				const preloadedSearch = window.__PRELOADED_SEARCH__;

				if (!preloadedSearch || preloadedSearch.cloudId !== requestedCloudId) {
					return null;
				}

				return preloadedSearch as PreloadedSearchPayload;
			},
		}),
		[isTransition],
	);
};
